var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative w-12 h-12 overflow-hidden border border-gray-300 rounded-full shadow-sm"},[_c('img',{class:[ 'w-full', { 'p-2': !_vm.hasImage }],attrs:{"src":_vm.businessImage,"alt":"Where's Weed user","width":_vm.width,"height":_vm.height},on:{"error":_vm.setFallbackImage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }